module.exports = __webpack_public_path__ + "assets1783936157458/img/kaifa.c87f510c.svg";